export const getPositionString = (page: CMSPageManifest, options = {seniority: true}) => {
  if (page.dma_name) return `${page.position_name} in ${page.dma_name}`;
  if (page.company_name) return `${page.position_name} at ${page.company_name}`;
  if (page.seniority_name && options.seniority)
    return `${page.seniority_name} ${page.position_name}`;
  return page.position_name;
};

export const getCompanyOrDMAString = (page: CMSPageManifest) => {
  if (page.dma_name) return `in ${page.dma_name}`;
  if (page.company_name) return `at ${page.company_name}`;
};

export const getSeniorityYOEString = (minYOE: number, maxYOE: number) => {
  if (maxYOE) return `${minYOE || 0}-${maxYOE} years of experience`;
  if (minYOE) return `${minYOE}+ years of experience`;
};

export const convertObjectToQueryString = (obj: {[key: string]: any}) =>
  Object.keys(obj)
    .map((key) => `${key}=${obj[key]}`)
    .join('&');

export const getUrlPrefix = (type: CMSPageType) => {
  switch (type) {
    case 'articles':
      return 'p';
    case 'salaries':
      return 'salaries';
    case 'interviews':
      return 'interview-guides';
    default:
      throw new Error(`Unknown cms page type: ${type}`);
  }
};
